import { FunctionComponent } from 'react'
import { Checkbox, FormControlLabel } from '@black-bear-energy/rucksack'

export const FilterMenuItem: FunctionComponent<FilterMenuItemProps> = ({
  label,
  checked,
  onChange,
}) => {
  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={onChange} />}
      label={label}
      sx={{
        py: '0.375rem',
        m: 0,
        userSelect: 'none',
      }}
    />
  )
}

interface FilterMenuItemProps {
  label: string
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}
